import React from "react";
import { View, Text } from "react-native";
import { RadioButton } from "react-native-paper";

interface Props {
  label: string;
  value: string;
  currentSelected: string;
  setValue: (value: string) => void;
}

export default function ButtonRadio(props: Props) {
  return (
    <View className="flex-row items-center">
      <RadioButton
        value={props.value}
        status={props.currentSelected === props.value ? "checked" : "unchecked"}
        onPress={() => props.setValue(props.value)}
        color="#5D0CBA"
      />
      <Text className="text-sm font-light">{props.label}</Text>
    </View>
  );
}
